module.exports = __webpack_public_path__ + "static/media/v3.2b834f7d.PNG";